import axios from 'axios'
import {clearPersistedSession} from '~/assets/utils/PersistedSession'

export default function (context) {
	axios.interceptors.response.use(res => {
		return res
	}, async error => {
		if (error.response && error.response.status === 401) {
			console.log(error)
			context.store.dispatch('RESET_STATE')
			clearPersistedSession(context.app.$cookies, {
				authStorageKeys: context.$config.persistedSessionAuthStorageKeys
			})
			await context.$auth.logout().catch(logoutError => console.error(logoutError))
		}
		throw error
	})
}
